import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Container,
  Grid,
  Typography,
  Link,
  Divider,
} from '@mui/material';

const Footer: React.FC = () => {
  return (
    <Box
      component="footer"
      sx={{
        bgcolor: 'primary.main',
        color: 'white',
        py: 6,
        mt: 'auto',
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" gutterBottom>
              О журнале
            </Typography>
            <Typography variant="body2">
              Тюменский научный журнал - рецензируемое научное издание,
              публикующее оригинальные исследования в различных областях науки.
            </Typography>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" gutterBottom>
              Навигация
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Link
                component={RouterLink}
                to="/"
                color="inherit"
                sx={{ textDecoration: 'none' }}
              >
                Главная
              </Link>
              <Link
                component={RouterLink}
                to="/issues"
                color="inherit"
                sx={{ textDecoration: 'none' }}
              >
                Выпуски
              </Link>
              <Link
                component={RouterLink}
                to="/articles"
                color="inherit"
                sx={{ textDecoration: 'none' }}
              >
                Статьи
              </Link>
              <Link
                component={RouterLink}
                to="/authors"
                color="inherit"
                sx={{ textDecoration: 'none' }}
              >
                Авторы
              </Link>
            </Box>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" gutterBottom>
              Контакты
            </Typography>
            <Typography variant="body2" paragraph>
              Email: tyumen-science@yandex.ru
            </Typography>
            <Typography variant="body2" paragraph>
              Телефон: +7(912)995-75-35
            </Typography>
            <Typography variant="body2">
              Адрес: г.Тюмень, ул.Одесская, д.9, оф.511, 625023
            </Typography>
          </Grid>
        </Grid>
        <Divider sx={{ my: 3, bgcolor: 'rgba(255, 255, 255, 0.2)' }} />
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            justifyContent: 'space-between',
            alignItems: { xs: 'flex-start', sm: 'center' },
            gap: 1,
          }}
        >
          <Typography variant="body2">
            © {new Date().getFullYear()} Тюменский научный журнал. Все права защищены.
          </Typography>
          <Link
            component={RouterLink}
            to="/privacy-policy"
            color="inherit"
            sx={{ textDecoration: 'underline' }}
          >
            Политика конфиденциальности
          </Link>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer; 